<h2 class="loren-asset-details-analysis-title">
  {{ "asset_details.analysis_title" | transloco }}
</h2>
<div class="loren-asset-details-analysis-grid">
  @for(metering of meterings(); track metering) {
  <loren-loren-asset-details-analysis-item [metering]="metering">
  </loren-loren-asset-details-analysis-item>
  }
</div>
